import { render } from "./HomeFeedSubpage.vue?vue&type=template&id=ed6d44c8&scoped=true"
import script from "./HomeFeedSubpage.vue?vue&type=script&lang=js"
export * from "./HomeFeedSubpage.vue?vue&type=script&lang=js"

import "./HomeFeedSubpage.vue?vue&type=style&index=0&id=ed6d44c8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed6d44c8"]])

export default __exports__